import _, {isEqual} from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {CardActionsEnum} from './cardsActions';

const cardsUpdatedReducer = createResourcesUpdatedReducer('cards', (card) => card.id, mergeCard);

export function cardsReducer(state: ResourceMap<CardModel>, action: AppAction): ResourceMap<CardModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return cardsUpdatedReducer(state, action);

    case CardActionsEnum.CARDS_DELETED:
      return _(state).omit(action.payload.cardIds).value();

    default:
      return state;
  }
}

function mergeCard(existingCard: CardModel | undefined, updatedCard: CardModel) {
  if (!existingCard) {
    return updatedCard;
  }

  if (isEqual(existingCard, updatedCard)) {
    return existingCard;
  }

  return {
    ...updatedCard,
    // Cards can sometimes be serialized without custom attributes (updatedCard.customFieldAttributes will be parsed as undefined)
    // If that's the case, preserve the existing custom attributes
    customFieldAttributes: updatedCard.customFieldAttributes ?? existingCard.customFieldAttributes,
  };
}
